import { apiService } from "./apiService";
import { endpoints } from "../config/endpoints";
import pickBy from "lodash/pickBy";

export default {
  postOrder(payload) {
    return apiService.post(endpoints.payments.root, payload);
  },
  getPlans() {
    return apiService.get(endpoints.payments.plans);
  },
  getPricePreview(payload) {
    return apiService.post(endpoints.payments.pricePreview, payload);
  },
  postAfterPayment(payload) {
    return apiService.post(endpoints.payments.afterPayment, payload);
  },
  postInitialChosenPlan(payload) {
    return apiService.post(endpoints.payments.initialChosenPlan, payload);
  },
  getInitialChosenPlan() {
    return apiService.get(endpoints.payments.initialChosenPlan);
  },
  pay() {
    return apiService.get(endpoints.payments.latestPayment);
  },
  getPromotionCodes() {
    return apiService.get(endpoints.payments.promotionCodes);
  },
  getCampaigns(campaignId) {
    return apiService.get(endpoints.payments.campaigns(campaignId));
  }
};
